import axios from 'axios';
import { getToken, getTokenWs, getIpAddress } from './Common'
import { getUser, handleLogout } from 'src/utils/Common'
import axiosRetry from 'axios-retry'; // YENİ: Otomatik tekrar deneme

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

instance.interceptors.request.use(
  function (config) {
    if (config.url) {
      // 1. Çift slash temizliği (Protokol kısmını bozmadan)
      config.url = config.url.replace(/([^:]\/)\/+/g, "$1");

      // 2. Parçalara ayır ve temizle
      let parts = config.url.split('/');
      parts = parts.map(part => {
        if (!part) return part;
        const lower = part.toLowerCase().trim();
        // Sadece değer bazlı null/undefined kontrolü
        return (lower === 'null' || lower === 'undefined') ? '0' : part;
      });

      // 3. Yeniden birleştir
      config.url = parts.join('/');

      // 4. NOKTA SORUNU İÇİN ÇÖZÜM: 
      // Eğer URL'de nokta varsa ve sonunda slash yoksa, sonuna slash ekle.
      // Bu, sunucunun (IIS/Nginx) bunu dosya sanmasını engellemek için en etkili yoldur.
      if (config.url.includes('.') && !config.url.endsWith('/')) {
        config.url += '/';
      }

      // Temizlik
      config.url = config.url.trim().replace(/\*$/, "");
    }
    let AuthToken = getToken();
    let AuthTokenWs = getTokenWs();
    let IpAddress = getIpAddress();
    let user = getUser();
    config.headers = {
      ...config.headers,
      'Authorization': 'Bearer ' + AuthToken,
      'SessionToken': AuthToken,
      'SessionTokenWs': AuthTokenWs,
      'IpAddress': IpAddress || '',
      'Auth-UserId': user ? user.UserId : '',
      // 'max-age': 86400,
      // 'X-Frame-Options': 'DENY',
      // 'X-XSS-Protection': '1;mode=block',
      // 'Access-Control-Allow-Origin': '*'
    };
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
axiosRetry(instance, {
  retries: 3,
  retryCondition: (error) => {
    return axiosRetry.isNetworkOrIdempotentRequestError(error);
  },
  retryDelay: axiosRetry.exponentialDelay
});


// Hata Raporlama Fonksiyonu (Sessizce çalışır)
const reportErrorToDB = async (error) => {
  try {
    const sessionUser = getUser();
    let AuthToken = getToken();
    let AuthTokenWs = getTokenWs();
    let IpAddress = getIpAddress();

    const requestParam = {
      category: "Axios_Interceptor_Silent",
      rating: -13,
      description: `SAYFA: ${window.location.pathname} | MESAJ: ${error.message} | URL: ${error.config?.url} | STATUS: ${error.response?.status} | DATA: ${JSON.stringify(error.response?.data)}`.trim(),
      fileName: "Axios_Interceptor",
      UserId: sessionUser?.UserId || 0,
      ServiceShopId: 0,
      imageBase64: '',

    };
    // Kendi üzerinden değil, sonsuz döngüyü engellemek için doğrudan axios ile atıyoruz
    axios.post(process.env.REACT_APP_API_URL + '/SetTechnicianFeedback', requestParam,
      {
        headers: {
          Authorization: 'Bearer ' + AuthToken,
          SessionToken: AuthToken,
          SessionTokenWs: AuthTokenWs,
          IpAddress: IpAddress || '',
          'Auth-UserId': sessionUser?.UserId || 0
        }
      });
  } catch (e) {
    // Hata raporlama başarısız oldu
  }
};

// --- INTERCEPTOR (KORUMA KALKANI) ---
instance.interceptors.response.use(
  (response) => response, // Başarılı istekler direkt geçer
  (error) => {
    let userMessage = "Şu an işleminizi gerçekleştiremiyoruz. Lütfen kısa süre sonra tekrar deneyiniz.";
    // 2. Özel Durum: 401 Unauthorized (Oturum sonlandırma)
    if (error.response && error.response.status === 401) {
      alert("Başka bir cihazdan giriş yaptığınız için veya oturum süreniz dolduğu için oturumunuz sonlandırıldı!..");
      handleLogout();
      return new Promise(() => { });
    }

    if (error.message === "Network Error" || error.code === "ERR_NETWORK"
      || typeof error.response === 'undefined' || !error.response
      || error.message.includes('timeout') || error.code === 'ECONNABORTED') {
      if (!axiosRetry.isNetworkOrIdempotentRequestError(error)) {
        // 1. Hatayı arka planda sessizce raporla
        reportErrorToDB(error);
        userMessage = "İnternet bağlantınız çok zayıf. Lütfen sinyali kontrol edip tekrar deneyiniz.";
        alert(userMessage);
      }
      return new Promise(() => { });
    }

    // 1. Hatayı arka planda sessizce raporla
    reportErrorToDB(error);

    // 3. Özel Durum: ChunkLoadError (Versiyon yenileme)
    if (error.message.includes("Loading chunk") || error.name === "ChunkLoadError") {
      window.location.reload();
      return new Promise(() => { });
    }



    // 4. Durum: İnternet Yoksa
    if (!window.navigator.onLine) {
      userMessage = "İnternet bağlantınız koptu. Lütfen bağlantınızı kontrol edip tekrar deneyiniz.";
      alert(userMessage);
      return new Promise(() => { });
    }

    // 5. Durum: Sunucudan Cevap Gelmiyorsa (Network Error / Status: undefined)
    else if (!error.response) {
      userMessage = "Sunucuya bağlanılamadı. Lütfen internet sinyalinizi kontrol edip tekrar deneyiniz.";
      alert(userMessage);
      return new Promise(() => { });
    }

    // 6. Durum: Sunucu Hata Dönüyorsa (404, 500 vb.)
    else if (error.response) {
      const status = error.response.status;
      if (status === 404) {
        userMessage = "İnternet Bağlantı sorunu yaşanıyor. İstediğiniz bilgiye şu an ulaşılamadı. Lütfen tekrar deneyiniz.";
        alert(userMessage);
        return Promise.reject(error);
      } else if (status === 500) {
        if (error.response.data && error.response.data.error) {
          userMessage = error.response.data.error; // SQL'deki gerçek mesajı göster
        } else {
          userMessage = "Sistemde geçici bir yoğunluk yaşanıyor. Lütfen biraz bekleyip tekrar deneyiniz.";
        }
        alert(userMessage);
        return Promise.reject(error);
      }
      else if (status > 500) {
        // 502, 503 veya 504 gibi Gateway hataları için özel mesaj
        if (status === 502 || status === 504) {
          userMessage = "Lütfen internetinizin çektiğinden emin olup tekrar deneyiniz.";
        }
        // HTML döndüyse (IIS hata sayfası) ama status 500 ise
        else if (error.response.data && typeof error.response.data === 'string' && error.response.data.includes('<html>')) {
          userMessage = "Sunucu şu an bu talebi işleyemiyor. Lütfen kısa süre sonra tekrar deneyiniz.";
        }
        // DB'den gelen özel hata mesajı varsa (Örn: Bir önceki SMS örneği)
        else if (error.response.data && error.response.data.error) {
          userMessage = error.response.data.error;
        }
        else {
          userMessage = "Sistemde geçici bir yoğunluk var. Lütfen biraz bekleyip tekrar deneyiniz.";
        }
        alert(userMessage);
        return new Promise(() => { });
      }

    }
    else if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      userMessage = "Lütfen bağlantınızı kontrol edip tekrar deneyiniz.";
      alert(userMessage);
      return new Promise(() => { });
    }
    return Promise.reject(error);
  }
);



export default instance;
